import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ComponentActionForm from '../../../components/forms/ComponentActionForm';
import { useComponentActionApi } from '../../../hooks/useComponentActionApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { ComponentActionDTO } from '../../../services/apiClient';

const ComponentActionCreate: React.FC = () => {
  const { create, isLoading } = useComponentActionApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Component Actions', href: '/admin/componentactions' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ComponentActionDTO) => {
    try {
      await create(data);
      navigate('/admin/componentactions');
    } catch (error) {
      console.error('Error creating ComponentAction:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/componentactions"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.ComponentAction.Edit"
    >
        <ComponentActionForm
          initialValues={{} as ComponentActionDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/componentactions')}
        />
    </AdminLayout>
  );
};

export default ComponentActionCreate;
